import { render, staticRenderFns } from "./DownloadApp.vue?vue&type=template&id=8155116c&scoped=true"
import script from "./DownloadApp.vue?vue&type=script&lang=js"
export * from "./DownloadApp.vue?vue&type=script&lang=js"
import style0 from "./DownloadApp.vue?vue&type=style&index=0&id=8155116c&prod&lang=scss"
import style1 from "./DownloadApp.vue?vue&type=style&index=1&id=8155116c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8155116c",
  null
  
)

export default component.exports